export default "__VITE_ASSET__DwQm34R4__"